import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

/* Eagerly load the homepage — it's the landing page and must paint immediately */
import Home from "../pages/home/page";

/* Route-level code splitting — secondary pages load on demand as their own JS chunk */
const NotFound                    = lazy(() => import("../pages/NotFound"));
const AboutPage                   = lazy(() => import("../pages/about/page"));
const PrivacyPolicyPage           = lazy(() => import("../pages/privacy-policy/page"));
const TermsOfUsePage              = lazy(() => import("../pages/terms-of-use/page"));
const CaseStudiesIndexPage        = lazy(() => import("../pages/case-studies/page"));
const LocalCollectivePage         = lazy(() => import("../pages/case-studies/local-collective/page"));
const HealthcareBehavioralAVPage  = lazy(() => import("../pages/case-studies/healthcare-behavioral-av/page"));
const RequestACallPage            = lazy(() => import("../pages/request-a-call/page"));
const PlatformPage                = lazy(() => import("../pages/platform/page"));
const RequestACallConfirmationPage = lazy(() => import("../pages/request-a-call/confirmation/page"));
const SitemapPage                 = lazy(() => import("../pages/sitemap/page"));
const HospitalityAPACPage         = lazy(() => import("../pages/case-studies/hospitality-apac/page"));
const CorporateRealEstatePage     = lazy(() => import("../pages/case-studies/corporate-real-estate/page"));
const FaqPage                     = lazy(() => import("../pages/faq/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/platform",
    element: <PlatformPage />,
  },
  {
    path: "/request-a-call",
    element: <RequestACallPage />,
  },
  {
    path: "/request-a-call/confirmation",
    element: <RequestACallConfirmationPage />,
  },
  {
    path: "/case-studies",
    element: <CaseStudiesIndexPage />,
  },
  {
    path: "/case-studies/hospitality-apac",
    element: <HospitalityAPACPage />,
  },
  {
    path: "/case-studies/corporate-real-estate",
    element: <CorporateRealEstatePage />,
  },
  {
    path: "/case-studies/healthcare-behavioral-av",
    element: <HealthcareBehavioralAVPage />,
  },
  {
    path: "/case-studies/local-collective",
    element: <LocalCollectivePage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUsePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;